export default {
      id: "icon-cross-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "icons.svg#icon-cross",
      toString: function () {
        return this.url;
      }
    }